/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.additionalProducts.addToCart": "Dodaj do zamówienia",
  "i18n.additionalProducts.emotionalHook": "♥️ Najchętniej dodane:",
  "i18n.additionalProducts.productDescription": "Opis produktu",
  "i18n.additionalProducts.showMore": "Więcej informacji",
  "i18n.additionalProducts.title": "Odpowiednie dodatki ",
  "i18n.button.addToCart": "Dodaj do koszyka",
  "i18n.button.cropImage": "",
  "i18n.button.apply": "Zastosuj",
  "i18n.button.back": "Wstecz",
  "i18n.button.cancel": "Anuluj",
  "i18n.button.cancelAndFix": "",
  "i18n.button.cancelAndAddImage": "",
  "i18n.button.close": "Zamykaj",
  "i18n.button.continue": "Dalej",
  "i18n.button.ignore": "Pomijaj",
  "i18n.button.ignoreAndContinue": "Mimo to, dalej",
  "i18n.button.ignoreAndContinueOrder": "",
  "i18n.button.mobile.createNewTextPlaceholders": "Tekst",
  "i18n.button.noChanges": "Nie, dziękuję. Zamknij okno.",
  "i18n.button.design": "",
  "i18n.button.photos": "Zdjęcia",
  "i18n.button.retry": "Spróbuj ponownie",
  "i18n.button.uploadPhotos": "Prześlij zdjęcie / zdjęcia",
  "i18n.button.withSmartSorted": "Tak, wezmę SMART SORTED. ",
  "i18n.button.withoutSmartSorted": "Nie, dziękuję. Zamknij okno.",
  "i18n.button.continueDesigning": "",
  "i18n.button.returnToHomePage": "",
  "i18n.button.deleteImage": "",
  "i18n.button.withoutPhoto": "",
  "i18n.button.withoutThisPhoto": "",
  "i18n.button.chooseNewImage": "",
  "i18n.button.chooseOtherPhoto": "",
  "i18n.button.retryPhoto": "",
  "i18n.button.reload": "",
  "i18n.button.restartDesigner": "",
  "i18n.button.restart": "",
  "i18n.button.puzzleYouShop": "",
  "i18n.button.shop": "",
  "i18n.button.changeProduct": "",
  "i18n.button.keepProduct": "",
  "i18n.toggle.hidePuzzleOverlay": "",
  "i18n.toggle.showPuzzleOverlay": "",
  "i18n.toggle.hide": "",
  "i18n.toggle.showUsedImages": "",
  "i18n.toggle.hideUsedImages": "",
  "i18n.imagePromoter.title": "",
  "i18n.imagePromoter.content": "",
  "i18n.boxPromoter.title.puzzle": "",
  "i18n.boxPromoter.title.memo": "",
  "i18n.boxPromoter.title.default": "",
  "i18n.boxPromoter.content.designsAndText": "",
  "i18n.boxPromoter.content.designs": "",
  "i18n.boxPromoter.content.text": "",
  "i18n.control.actionBar.duplicate": "",
  "i18n.control.actionBar.editText": "",
  "i18n.control.actionBar.leaveTextEditing": "",
  "i18n.control.actionBar.delete": "",
  "i18n.control.actionBar.rotate": "",
  "i18n.control.colorChooser.matchingColors": "",
  "i18n.control.colorChooser.allColors": "",
  "i18n.control.colorChooser.allBgColors": "",
  "i18n.control.colorChooser.lowContrastHint": "",
  "i18n.control.fontChooser.group.classic": "",
  "i18n.control.fontChooser.group.creative": "",
  "i18n.control.fontChooser.group.handwritten": "",
  "i18n.control.fontChooser.group.modern": "",
  "i18n.control.fontChooser.group.technical": "",
  "i18n.control.imageQuality.title.good": "",
  "i18n.control.imageQuality.title.medium": "",
  "i18n.control.imageQuality.title.bad": "",
  "i18n.control.imageQuality.content.good": "",
  "i18n.control.imageQuality.content.medium": "",
  "i18n.control.imageQuality.content.bad": "",
  "i18n.control.imageQuality.affectedImages": [
    "",
    ""
  ],
  "i18n.control.imageQuality.showIndicators": "",
  "i18n.control.imageQuality.hideIndicators": "",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.textEditing.menu.fonts": "",
  "i18n.control.textEditing.menu.effects": "",
  "i18n.control.textEditing.menu.colors": "",
  "i18n.control.textEditing.menu.bgColors": "",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Aby uzyskać lepszą czytelność, skróć długość tekstu / linii.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Wybrana czcionka jest za duża dla tego tekstu.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Osiągnięto maksymalny możliwy rozmiar czcionki dla tego tekstu.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "Osiągnięto minmalny możliwy rozmiar czcionki dla tego tekstu.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Proszę wstawić przerwę w linii",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Kontynuuj pisanie w poniższym zdaniu lub powiększ pole tekstowe",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Prosimy o sprawdzenie textu. Ta czcionka nie obsługuje wszystkich znaków.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Aby uzyskać lepszą czytelność, skróć długość tekstu / linii.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Proszę powiększ pole tekstowe",
  "i18n.dialog.closeDesigner.message": "",
  "i18n.dialog.closeDesigner.title": "",
  "i18n.dialog.deletePlaceholder.message": "Tego kroku nie można cofnąć",
  "i18n.dialog.deletePlaceholder.title": "Chcesz usunąć symbol zastępczy?",
  "i18n.dialog.deleteGalleryImage.title": "",
  "i18n.dialog.deleteGalleryImage.message": "",
  "i18n.dialog.insufficientImageQuality.message": "Rozdzielczość tego zdjęcia jest za słaba na optymalną jakość druku!",
  "i18n.dialog.smartSorted.message": "Z sortowaniem wstępnym SMART SORTED ułożysz bez trudu innowacyjnym sposobem puzzle z 1000 elementów, również nie widząc wzoru motywu",
  "i18n.dialog.smartSorted.title": "Sukces w układaniu puzzli gwarantowany",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Kliknij \"{{text}}\", aby zmienić tytuł pudełka.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Tytuł pudełka nie został zmieniony",
  "i18n.dialog.unchangedPlaceholders.buttons.addTitle.label": "",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Dalej bez tytułu w pudełku",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "Proszę wstawić zdjęcie, klikając na symbol zastępczy",
    "Proszę wstawić zdjęcia klikając na symbole zastępcze",
    "Proszę wstawić zdjęcia klikając na symbole zastępcze"
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "Jeden element zastępczy jest nadal pusty",
    "Niektóre symbole zastępcze są nadal puste",
    "Niektóre symbole zastępcze są nadal puste"
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Symbol zastępczy nie został zmieniony.",
    "Niektóre symbole zastępcze nie zostały zmienione.",
    "Niektóre symbole zastępcze nie zostały zmienione."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "Kliknij symbol zastępczy tekstu, aby zmienić tekst",
    "Kliknij symbole zastępcze tekstu, aby zmienić teksty",
    "Kliknij symbole zastępcze tekstu, aby zmienić teksty"
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "Symbol zastępczy tekstu nie został zmieniony",
    "Niektóre symbole zastępcze tekstu nie zostały zmienione",
    "Niektóre symbole zastępcze tekstu nie zostały zmienione"
  ],
  "i18n.dialog.unchangedPlaceholders.title": "Nie zmienione symbole zastępcze",
  "i18n.dialog.productChooserWarning.title": "",
  "i18n.dialog.productChooserWarning.message": "",
  "i18n.dialog.imageQuality.title": "",
  "i18n.dialog.imageQuality.indicator.good": "",
  "i18n.dialog.imageQuality.indicator.medium": "",
  "i18n.dialog.imageQuality.indicator.bad": "",
  "i18n.dialog.imageQuality.subtitle.good": "",
  "i18n.dialog.imageQuality.subtitle.medium": "",
  "i18n.dialog.imageQuality.subtitle.bad": "",
  "i18n.dialog.imageQuality.content.good": "",
  "i18n.dialog.imageQuality.content.medium": "",
  "i18n.dialog.imageQuality.content.bad": "",
  "i18n.error.deprecatedBrowserError.message": "",
  "i18n.error.deprecatedBrowserError.title": "",
  "i18n.error.designerExpiredError.message": "Projekt został przerwany na dłuższy czas, niestety nie może być teraz kontynuowany. Prosimy o ponowne uruchomienie projektu.",
  "i18n.error.designerExpiredError.title": "",
  "i18n.error.fontLoadingError.message": "",
  "i18n.error.fontLoadingError.title": "",
  "i18n.error.imageLoadingError.message": "Jedno zdjęcie nie zostało wstawione. Został usunięty z obszaru projektu i galerii.",
  "i18n.error.imageLoadingError.title": "Błąd pobierania",
  "i18n.error.imageProvisionError.message": "Nie można przetworzyć zdjęcia lub niektórych zdjęć. Rodzaj mediów prawdopodobnie nie jest odpowiedni.",
  "i18n.error.imageProvisionError.title": "",
  "i18n.error.imageSelectionError.message": "Nie można przetworzyć \"{{reference1}}\"",
  "i18n.error.imageSelectionError.title": "Błąd podczas przesyłania zdjęć",
  "i18n.error.imageSizeLimitExceededError.message": "Załadowane zdjęcie ma za duży rozmiar.\nProsimy zmniejszyć je do rozmiaru mniejszego niż 180 megapikseli i załadować ponownie.",
  "i18n.error.imageSizeLimitExceededError.title": "Błąd podczas przesyłania zdjęć",
  "i18n.error.imageUploadError.message": "Wystąpił problem z połączeniem internetowym. Spróbuj ponownie później.",
  "i18n.error.imageUploadError.title": "Błąd podczas przesyłania zdjęć",
  "i18n.error.inlineSVGLoadingError.message": "",
  "i18n.error.inlineSVGLoadingError.title": "",
  "i18n.error.invalidCharConfigError.message": "Tego typu czcionki nie można użyć, wybierz inną czcionkę.",
  "i18n.error.invalidCharConfigError.title": "Typ czcionki nie nadaje się",
  "i18n.error.malformedProductError.message": "",
  "i18n.error.malformedProductError.title": "",
  "i18n.error.notInStockError.message": "",
  "i18n.error.notInStockError.title": "",
  "i18n.error.offlineNotice": "Twoje połączenie internetowe zostało przerwane. Możesz kontynuować projektowanie swojego produktu zaraz po przywróceniu połączenia.",
  "i18n.error.templateLoadingError.message": "Nie można załadować szablonu \"{{ error.reference[0] }}\". Spróbuj ponownie później.",
  "i18n.error.templateLoadingError.title": "Błąd pobierania",
  "i18n.error.traudlLoadingError.message": "",
  "i18n.error.traudlLoadingError.title": "",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" ma nieodpowiedni typ mediów.",
  "i18n.error.unsupportedMediaTypeError.title": "Błąd podczas przesyłania zdjęć",
  "i18n.error.uploadProductError.message": "Produkt lub niektórych produktów nie można przenieść na serwer. Spróbuj ponownie później.",
  "i18n.error.uploadProductError.title": "Błąd transferu",
  "i18n.error.zoomModeError.message": "Tekst z poprzedniego projektu nie mógł zostać przyjęty. Wprowadź nowy tekst.",
  "i18n.error.zoomModeError.title": "Tekst nie został przyjęty",
  "i18n.gallery.uploadPhotos.title": "",
  "i18n.gallery.uploadPhotos.message": "",
  "i18n.gallery.placedAllPhotos.title": "",
  "i18n.gallery.placedAllPhotos.message": "",
  "i18n.price.price": "Cena",
  "i18n.price.reduction": "Zaoszczędzisz",
  "i18n.price.total": "Cena całkowita",
  "i18n.priceDisplay.times": [
    "{{value}} sztuk po {{pricePerUnit}} zł każda",
    "{{value}} sztuk po {{pricePerUnit}} zł każda",
    "{{value}} sztuk po {{pricePerUnit}} zł każda"
  ],
  "i18n.progress.stepAdditionalProducts": "Wybierz dodatki",
  "i18n.progressOverlay.message.lines.one": "Dziękujemy za starannie przygotowany projekt.",
  "i18n.progressOverlay.message.lines.two": "Przygotujemy następujący krok...",
  "i18n.template.insertText": "Wpisz tutaj tekst",
  "i18n.toolbox.image.title": "Edytuj zdjęcie",
  "i18n.toolbox.layout.template.count": [
    "",
    "",
    ""
  ],
  "i18n.toolbox.layout.template.inUse": "",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 zdjęcie",
    "{{value}} zdjęcia",
    "{{value}} zdjęć"
  ],
  "i18n.toolbox.layout.title": "",
  "i18n.toolbox.layout.titleBox": "",
  "i18n.toolbox.preview.title": "Podgląd 3D",
  "i18n.toolbox.productChooser.title": "Zmień produkt",
  "i18n.toolbox.productChooser.triggerText": "Produkt",
  "i18n.toolbox.productChooser.contentMessage.one": "",
  "i18n.toolbox.productChooser.contentMessage.two": "",
  "i18n.toolbox.textEdit.title": "",
  "i18n.toolbox.textEdit.noPlaceholdersTitle": "",
  "i18n.toolbox.textEdit.noPlaceholdersMessage": "",
  "i18n.toolbox.textEdit.noPlaceholdersButton": "",
  "i18n.toolbox.text.title": "Edytuj tekst",
  "i18n.toolbox.imageEdit.title": "",
  "i18n.toolbox.imageEdit.removeImageMobile": "",
  "i18n.toolbox.imageEdit.removeImageDesktop": "",
  "i18n.toolbox.imageEdit.swapImage": ""
};


export class LocalePlPL {
  public getPlural(n: number): number
  {
    const pluralForm = (n==1 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
